import React, { useState, useEffect, useContext } from "react";

import { simpleMessage } from "../../../helpers/Helpers";
import { getToken } from "../../../api/Account";
import { DataContext } from "../../../context/DataContext";
import { getChartDiaAsync } from "../../../api/Dashboard";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { chartPalette, chartTextColor, chartGridColor } from "../../../theme";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const ChartDia = ({ selectedSucursal }) => {
  const [labels, setLabels] = useState([]);
  const [data, setData] = useState([]);

  const { setIsLoading, setIsUnautorized, isDarkMode } = useContext(DataContext);

  const token = getToken();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getChartDiaAsync(token, selectedSucursal);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);

      let names = [];
      let val = [];
      result.data.result.forEach(function (i) {
        names.push(i.gestor);
        val.push(i.montoCobrado);
      });
      setLabels(names);
      setData(val);
    })();
  }, [selectedSucursal]);

  const textColor = chartTextColor(isDarkMode);
  const gridColor = chartGridColor(isDarkMode);
  const palette = chartPalette(isDarkMode);

  const options = {
    responsive: true,
    aspectRatio: 5,
    maintainAspectRatio: false,

    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";

            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += new Intl.NumberFormat("es-NI", {
                style: "currency",
                currency: "NIO",
              }).format(context.parsed.y);
            }
            return label;
          },
        },
      },
    },

    scales: {
      x: {
        ticks: { color: textColor },
        grid: { color: gridColor },
      },
      y: {
        ticks: {
          color: textColor,
          callback: (value) => {
            return new Intl.NumberFormat("es-NI", {
              style: "currency",
              currency: "NIO",
            }).format(value);
          },
        },
        grid: { color: gridColor },
        beginAtZero: true,
      },
    },
  };

  const dataSet = {
    labels,
    datasets: [
      {
        data: data,
        backgroundColor: palette.bg,
        borderColor: palette.border,
        borderWidth: 1,
        maxBarThickness: 56,
        borderRadius: 6,
      },
    ],
  };

  return (
    <div>
      <Bar data={dataSet} options={options} />
    </div>
  );
};

export default ChartDia;
